class ProductGalleryCounter extends HTMLElement {
  connectedCallback() {
    this.carousel = document.getElementById(this.getAttribute('aria-controls'));
    if (!this.carousel) return;

    this.currentElement = this.querySelector('[data-gallery-counter-current]');
    this.totalElement = this.querySelector('[data-gallery-counter-total]');
    this.abortController = new AbortController();
    this.updateFrame = null;

    this.carousel.addEventListener('carousel:change', () => this.queueUpdate(), {
      signal: this.abortController.signal
    });
    this.carousel.addEventListener('carousel:settle', () => this.queueUpdate(), {
      signal: this.abortController.signal
    });

    this.mediaObserver = new MutationObserver(() => this.queueUpdate());
    this.mediaObserver.observe(this.carousel, {
      subtree: false,
      attributes: true,
      attributeFilter: ['hidden']
    });

    this.queueUpdate();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.mediaObserver?.disconnect();

    if (this.updateFrame) {
      cancelAnimationFrame(this.updateFrame);
    }
  }

  queueUpdate() {
    if (this.updateFrame) {
      cancelAnimationFrame(this.updateFrame);
    }

    this.updateFrame = requestAnimationFrame(() => {
      this.updateFrame = null;
      this.update();
    });
  }

  update() {
    const visibleMedia = Array.from(
      this.carousel.querySelectorAll(':scope > .product-gallery__media:not([hidden])')
    );

    if (visibleMedia.length === 0) return;

    const selectedMedia =
      this.carousel.selectedCell ||
      visibleMedia.find((media) => media.classList.contains('is-initial')) ||
      visibleMedia[0];
    const selectedIndex = Math.max(visibleMedia.indexOf(selectedMedia), 0);
    const current = selectedIndex + 1;
    const total = visibleMedia.length;

    this.currentElement.textContent = current;
    this.totalElement.textContent = total;
    this.setAttribute('aria-label', `Media ${current} of ${total}`);
  }
}

if (!window.customElements.get('product-gallery-counter')) {
  window.customElements.define('product-gallery-counter', ProductGalleryCounter);
}
